module.exports = __webpack_public_path__ + "img/org-time-zone.1062feb3.webp";